import moment from "moment"

const goDigitQuickReqGenation = (data) => {
    //console.log('goDigit', data)
    const currentDate = moment().format('YYYY-MM-DD')
    const policyTYpe = data.insureds.length > 1 ? 'FLOATER' : 'NONFLOATER'
    const expiryDate = moment().add(1, 'day').format('YYYY-MM-DD')
    const sumInsuredAmount = Number(data.sumInsuredValue) / 100000
    let enquiryId = ""
    const personsArogya = []
    const personsHLCP = []
    let reqBodyArogya ={}
    let reqBodyHLCP1 ={}
    let reqBodyHLCP2 ={}
    let reqBodyHLCP3 ={}

    //  var randStr = "";
    for (let letter = 1; letter <= 8; letter++) {
        enquiryId += letter % 2 == 0 ? Math.ceil(Math.random() * 9) : String.fromCharCode(Math.random() * (91 - 65) + 65);
    }

    //console.log('enqui', enquiryId)

    const contractArogya = {
        "contract": {
            "expiryDate": String(expiryDate),
            "nonAbsProductCode": "AROG1",
            "policyPeriod": Number(data.period),
            "policyType": policyTYpe,
            "startDate": String(currentDate),
            "subInsuranceProductCode": "AROGY",
            "sumInsured": data.sumInsuredValue,
            "zone": null
        },
    }
    const contractHLCP1 = {
        "contract": {
            "expiryDate": String(expiryDate),
            "nonAbsProductCode": "DSO01",
            "policyPeriod": Number(data.period),
            "policyType": policyTYpe,
            "startDate": String(currentDate),
            "subInsuranceProductCode": "HLCP",
            "sumInsured": data.sumInsuredValue,
            "zone": null
        },
    }
    const contractHLCP2 = {
        "contract": {
            "expiryDate": String(expiryDate),
            "nonAbsProductCode": "DGO01",
            "policyPeriod": Number(data.period),
            "policyType": policyTYpe,
            "startDate": String(currentDate),
            "subInsuranceProductCode": "HLCP",
            "sumInsured": data.sumInsuredValue,
            "zone": null
        },
    }
    const contractHLCP3 = {
        "contract": {
            "expiryDate": String(expiryDate),
            "nonAbsProductCode": "DDO01",
            "policyPeriod": Number(data.period),
            "policyType": policyTYpe,
            "startDate": String(currentDate),
            "subInsuranceProductCode": "HLCP",
            "sumInsured": data.sumInsuredValue,
            "zone": null
        },
    }
    const coverageHLCP = {
        "coverages": [
            {
                "coverType": "48717",
                "sumInsuredAmount": data.sumInsuredValue
            },
            {
                "coverType": "48718",
                "sumInsuredAmount": data.sumInsuredValue
            }
        ]
    }
    const coverageArogya = {
        "coverages": [
            {
                "coverType": "49965",
                "sumInsuredAmount": data.sumInsuredValue
            },
            {
                "coverType": "48734",
                "sumInsuredAmount": String(sumInsuredAmount)
            },
            {
                "coverType": "49966",
                "sumInsuredAmount": data.sumInsuredValue
            }
        ]
    }
    const address = {
        "addresses": [
            {
                "pincode": String(data.pincode),
                "zone": "B"
            }
        ],
    }
   

    data.insureds.map((insure, index) => {
        //console.log('relation',insure.relationShip.toUpperCase())
        let personArogyaObject = {
            "age": insure.Age,
            "relationship": insure.relationShip.toUpperCase(),
            "addresses": [...address.addresses],
            "coverages": [...coverageArogya.coverages]
        }
        let personHLCPObject = {
            "age": insure.Age,
            "relationship": insure.relationShip.toUpperCase(),
            "addresses": [...address.addresses],
            "coverages": [...coverageHLCP.coverages]
        }
        personsArogya.push(personArogyaObject)
        personsHLCP.push(personHLCPObject)

    })

    reqBodyArogya = {
        "enquiryId" : String(enquiryId),
        "partnerName" : "AGENT",
        "contract" : {...contractArogya.contract},
        "persons" : personsArogya
    }

    reqBodyHLCP1 = {
        "enquiryId" : String(enquiryId),
        "partnerName" : "AGENT",
        "contract" : {...contractHLCP1.contract},
        "persons" : personsHLCP
    }
    reqBodyHLCP2 = {
        "enquiryId" : String(enquiryId),
        "partnerName" : "AGENT",
        "contract" : {...contractHLCP2.contract},
        "persons" : personsHLCP
    }
    reqBodyHLCP3 = {
        "enquiryId" : String(enquiryId),
        "partnerName" : "AGENT",
        "contract" : {...contractHLCP3.contract},
        "persons" : personsHLCP
    }

    //console.log('policyTp', policyTYpe, contractArogya)
    //console.log('coverag', coverageHLCP, coverageArogya)
    //console.log('persons', personsArogya, personsHLCP)
    //console.log('req',reqBodyArogya)
    //console.log('req',JSON.stringify(reqBodyArogya))

    return {reqBodyArogya,reqBodyHLCP1,reqBodyHLCP2,reqBodyHLCP3}

}

export default goDigitQuickReqGenation